import { createReducer, on } from '@ngrx/store';
import { UserState } from './user.state';
import * as UserActions from './user.actions';
import { Convert } from '../../models/user-model';

const initialState: UserState = {
  user: null, // Set to null initially instead of a default object
  sellerCoverImage: null,
  buyerCoverImage: null
};

export const userReducer = createReducer(
  initialState,
  on(UserActions.loginSuccess, (state, { user }) => ({
    ...state,
    user: user, // Correctly update the user state
  })),
  on(UserActions.logout, (state) => ({
    ...state,
    user: Convert.getDefaultUserModel(), // Reset the user state
  }))
);